import React from "react"

function IconStatusOffline({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="status-offline"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-status-offline"
      {...props}
    >
      <path
        d="m16.754 3.408-1.058 1.908A7.596 7.596 0 0 0 12 4.364V2.182c1.685 0 3.311.426 4.754 1.226zm4.595 5.586-2.077.667a7.64 7.64 0 0 0-2.043-3.226l1.495-1.59a9.821 9.821 0 0 1 2.625 4.149zm-.476 7.213-1.97-.936a7.612 7.612 0 0 0 .719-3.745l2.178-.134a9.795 9.795 0 0 1-.926 4.815zm-5.293 4.938-.796-2.032a7.657 7.657 0 0 0 3.094-2.238l1.679 1.394a9.84 9.84 0 0 1-3.977 2.876zm-7.227-.027.811-2.025a7.634 7.634 0 0 0 3.782.485l.267 2.166a9.819 9.819 0 0 1-4.86-.626zM3.06 16.064l1.986-.904a7.67 7.67 0 0 0 2.4 2.97l-1.302 1.751a9.851 9.851 0 0 1-3.084-3.817zm-.386-7.14 2.072.683a7.664 7.664 0 0 0-.252 3.806l-2.145.4a9.873 9.873 0 0 1 .325-4.889zm4.7-5.586 1.03 1.924A7.678 7.678 0 0 0 5.59 7.847L3.76 6.658a9.86 9.86 0 0 1 3.613-3.32zM12 2.182v2.182c-.59 0-1.169.066-1.732.197l-.492-2.126A9.845 9.845 0 0 1 12 2.182z"
        fill={color}
        fillRule="nonzero"
        style={{ height: height || fontSize }}
        originalclass="__secondary"
      />
    </svg>
  )
}

export default IconStatusOffline
